var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecoveryBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 303,
    height: 297,
    viewBox: "0 0 303 297",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2863 28.157C18.5727 37.1802 14.8953 57.8894 28.1017 92.1232C32.8427 104.413 39.4634 117.511 47.8361 130.956C59.7769 115.056 73.7519 99.1881 89.5299 83.9515C103.961 70.0157 118.867 57.6058 133.784 46.8823C118.98 38.1269 104.607 31.3665 91.2419 26.7395C56.5681 14.7359 35.9999 19.1338 27.2863 28.157ZM151.5 34.9344C209.315 -1.50467 264.507 -11.4234 289.693 14.6575C314.291 40.1296 303.572 93.007 267.253 148.105C303.584 203.21 314.309 256.099 289.707 281.574C264.519 307.657 209.321 297.735 151.5 261.288C93.6793 297.735 38.4806 307.657 13.2925 281.574C-11.309 256.099 -0.58432 203.21 35.7469 148.105C-0.57254 93.007 -11.291 40.1296 13.3071 14.6575C38.4931 -11.4234 93.6846 -1.50467 151.5 34.9344ZM151.5 58.1883C167.66 69.2567 184.055 82.5612 199.971 97.9307C216.937 114.315 231.577 131.325 243.654 148.106C231.575 164.892 216.929 181.91 199.956 198.301C184.045 213.666 167.656 226.967 151.5 238.033C135.344 226.967 118.955 213.666 103.044 198.301C86.0706 181.91 71.4253 164.892 59.3458 148.106C71.4225 131.325 86.0628 114.315 103.029 97.9307C118.945 82.5612 135.339 69.2567 151.5 58.1883ZM47.8347 165.254C59.7791 181.162 73.7595 197.037 89.5445 212.28C103.971 226.212 118.873 238.619 133.785 249.34C118.976 258.1 104.598 264.864 91.2273 269.492C56.5535 281.496 35.9852 277.098 27.2716 268.075C18.5581 259.052 14.8806 238.342 28.087 204.109C32.8305 191.812 39.4558 178.707 47.8347 165.254ZM169.215 249.34C184.127 238.619 199.029 226.212 213.455 212.28C229.24 197.037 243.221 181.161 255.165 165.254C263.544 178.707 270.169 191.812 274.913 204.109C288.119 238.342 284.442 259.052 275.728 268.075C267.015 277.098 246.446 281.496 211.773 269.492C198.402 264.864 184.024 258.1 169.215 249.34ZM255.164 130.956C243.223 115.056 229.248 99.1881 213.47 83.9515C199.039 70.0157 184.133 57.6058 169.216 46.8823C184.02 38.1269 198.393 31.3665 211.758 26.7395C246.432 14.7359 267 19.1338 275.714 28.157C284.427 37.1802 288.105 57.8894 274.898 92.1232C270.157 104.413 263.536 117.511 255.164 130.956Z",
    fill: "url(#paint0_linear_9283_18313)",
    fillOpacity: 0.05
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9283_18313",
    x1: 151.5,
    y1: 9,
    x2: 151.5,
    y2: 268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecoveryBackground);
export default __webpack_public_path__ + "static/media/recoveryBackground.bb0e4089a8e71bae72d296ec13806cba.svg";
export { ForwardRef as ReactComponent };